export default __webpack_public_path__ + "static/media/ep6TN5.df97c33c.jpg";